export const ALLOWED_PLANS = ['3m', '6m', 'sub']

export const plansPayload = {
  '3m': {
    name: '3 months',
    translatedName: '3 miesiące',
    subscription: false,
    priceId: 'price_1NrdHyEdH2OCjyD5FRtdla4P'
  },
  '6m': {
    name: '6 months',
    translatedName: '6 miesięcy',
    subscription: false,
    priceId: 'price_1NrdHIEdH2OCjyD5WQxLMLCB'
  },
  sub: {
    name: 'monthly subscription',
    translatedName: 'Subskrypcja',
    subscription: true,
    months: 0,
    priceId: 'price_1NrdPlEdH2OCjyD5MvpEIuBs'
  }
}

export const getPlanPayload = (planId = window.localStorage.getItem('tgfcPlan')) => {
  if (!ALLOWED_PLANS.includes(planId)) {
    throw new Error('The chosen plan does not exist')
  }

  return plansPayload[planId]
}
